import { render } from "./AdminUserGrid.vue?vue&type=template&id=0af179d5"
import script from "./AdminUserGrid.vue?vue&type=script&lang=js"
export * from "./AdminUserGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__